function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RecommendationListing.css';
import React, { Fragment } from 'react';
import { canUseDOM, get, getColorByTheme, getDictionaryItem, getPageThemeColors, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import LoadMore from '../DynamicListingComponent/LoadMore';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import { POIBlock } from './../34_POIs/POIs';
import { ArticleBlock } from '../02_Articles/Articles';
import EventBlock from '../15_Events/components/EventBlock';
import FeaturedEventBlock from '../15_Events/components/FeaturedEventBlock';
import { commonStyles as itemStyles, RecommendationItenaryBlock } from '../26_Itineraries/Itineraries';
import { commonStyles as curatorltrStyles, CuratorBlock, rtlStyles as curatorRtlStyles, emptyModalVideo, videplayerStyles } from '../10_Curators/Curators';
import throttle from 'lodash/throttle';
import clsx from 'clsx';
import Loader from '../atoms/Loader/Loader';
import { ReactComponent as IconPauseItem } from '../../resources/icons/IconPauseFat.svg';
import { ReactComponent as IconPlay } from '../../resources/icons/IconPlay2.svg';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from './Filters';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
import { convertQueryParamsToFacetsWithoutPlusReplacement, getAlgoliaTagsList } from './index';
import { getAnaliticsParamFromArray, tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { UniversityBlock } from './UniversityBlock';
import { DealBlock } from './ListingBlocks/DealBlock';
import { DealModalBlock } from './ListingBlocks/DealModalBlock';
import { ServicesBlock } from './ListingBlocks/ServicesBlock';
import { eventDatesRange } from './DateRange';
import { VideoBlock, videoMedia } from '../BrightcoveVideos';
import { VenueBlock } from '../VenueBlock/VenueBlock';
import Modal from '../atoms/Modal/Modal';
import { useModal } from '../atoms/Modal/useModal';
import ResultItem from '../DynamicListingComponent/ResultItem';
import { usePrevious } from '../../utils/usePrevious';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isShowRuleIsHide } from '../atoms/BlurCard/BlurCard';
import { checkJssError } from '../../utils/checkJssError';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
import { commonListingLtrStyles, commonListingRtlStyles, commonListingStyles } from '../Listing/commonListingStyles';
import useProfile from '../../utils/hooks/useProfile';
const getFacetNamesValue = filterData => {
  if (filterData) {
    return filterData.values.map(filter => {
      const item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      const item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      const facet = item1 || item2 || 'datesRange';
      if (facet === 'maxDelegates') {
        return 'maxDelegatesRangeIndex';
      }
      return facet;
    });
  } else {
    return [];
  }
};
const RecommendationListingComponent = _ref => {
  let {
    fields,
    params,
    route
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const pageTitle = get(sitecoreContext, 'route.fields.Title.value') || '';
  const currentLang = get(sitecoreContext, 'language');
  const userProfile = useProfile();
  const searchIndexParams = get(params, 'SearchIndex', '');
  const [fieldsColorTheme] = get(route, 'fields.Color Theme', [{}]);
  const backgroundPrimaryColor = get(fieldsColorTheme, 'fields.Primary.fields.backgroundColor.value', '');
  const typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  const filterData = get(fields, 'data.listingConfiguration.filters') || [];
  const isTagPage = get(fields, 'data.listingConfiguration.isTagPage.jss.value');
  const filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  const pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value'));
  const pinnedArray = get(fields, 'data.listingConfiguration.pinnedTypes.types') || [];
  const isSumOrFiltersScores = get(fields, 'data.listingConfiguration.isSumOrFiltersScores.jss.value', false);
  const pinned = pinnedArray.length !== 0 ? pinnedArray.map(el => el.template.targetItem.value) : [];
  const tagsSlugMap = get(fields, 'data.overwiewPages.pages').reduce((acc, slug) => {
    const key = slug.contentType.targetItem.template.targetItem.value;
    const value = slug.link.jss.value.href;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [key]: value
    });
  }, {});
  const dictionary = get(fields, 'data.dictionary');
  const buttonsDictionary = get(fields, 'data.buttonsDictionary');
  const imageDictionary = get(fields, 'data.imageDictionary');
  const curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  const byCopy = getDictionaryItem(dictionary, 'By');
  const MinRead = getDictionaryItem(dictionary, 'MinRead');
  const LoadMoreCopy = getDictionaryItem(dictionary, 'LoadMore');
  const day = getDictionaryItem(dictionary, 'Day') || 'day';
  const days = getDictionaryItem(dictionary, 'Days') || 'days';
  const showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  const resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  const clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'ClearAll';
  const selectAllLabel = getDictionaryItem(dictionary, 'ShowAll') || 'Select all';
  const Cancel = getDictionaryItem(dictionary, 'Cancel') || 'Cancel';
  const FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'Filters';
  const seeMore = getDictionaryItem(dictionary, 'SeeMore') || 'See More';
  const viewedNofMLabel = `${getDictionaryItem(dictionary, 'YouHaveViewed')} {#loadedHits#} ${getDictionaryItem(dictionary, 'Of')} {#nbHits#} ${getDictionaryItem(dictionary, 'Items')}`;
  const multipleDates = getDictionaryItem(dictionary, 'multipleDates') || 'Multiple days, next on';
  const fromText = getDictionaryItem(dictionary, 'from') || '#';
  const offText = getDictionaryItem(dictionary, 'off') || '#';
  const expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '#';
  const moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '#';
  const bookNowText = getDictionaryItem(dictionary, 'Book now') || '#';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '#';
  const readMoreText = getDictionaryItem(dictionary, 'readMore') || '#';
  const readLessText = getDictionaryItem(dictionary, 'readLess') || '#';
  const ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  const ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  const messageSearchResultEmpty = get(fields, 'data.contextItem.messageSearchResultEmpty.value', '');
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const [result, setResult] = React.useState();
  const [facets, setFacets] = React.useState();
  const [defaultFacets, setdefaultFacets] = React.useState();
  const [facetsStats, setFacetsStats] = React.useState({});
  const [hits, setHits] = React.useState([]);
  const [nbHits, setNbHits] = React.useState(0);
  const [page, setpage] = React.useState(0);
  const [firstRendering, setFirstRendering] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [buttonPressed, setButtonPressed] = React.useState(false);
  const [countAlgoliaCalls, setCountAlgoliaCalls] = React.useState(0);
  const [isTypeSetToUrl, setIsTypeSetToUrl] = React.useState(false);
  const [modalVideoState, setModalVideoState] = React.useState(emptyModalVideo);
  const [resetFilter, setResetFilter] = React.useState(false);
  const [resetAllFilters, setResetAllFilters] = React.useState(false);
  const [setFilters, applySetFilters] = React.useState(false);
  const [currentTypes, applycurrentTypes] = React.useState([]);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const location = useLocation();
  const {
    isShown,
    toggle
  } = useModal();
  const [dealModalItem, setIdDealModalItem] = React.useState({});
  const [isChina, setIsChina] = React.useState(false);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const isFirstLoadWithoutFacets = React.useRef(false);
  const modalVideo = React.useRef(null);
  const urlParams = new URLSearchParams(canUseDOM ? window.location.search : undefined);
  const typeFromUrl = urlParams.get('type');
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const socialSharing = get(fields, 'data.socialSharing');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  React.useEffect(() => {
    if (canUseDOM && document.body) {
      const primaryColor = selectedPrimaryColor;
      const color = getColorByTheme(selectedPrimaryColor);
      const activeColor = selectedPrimaryActiveColor;
      document.body.style.setProperty('--venue-table-background-color', primaryColor);
      document.body.style.setProperty('--venue-table-background-active-color', activeColor);
      document.body.style.setProperty('--venue-table-color', color);
    }
  }, []);
  const queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  let facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, filterData);
  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      const urlParams = new URLSearchParams(document.location.search);
      const isC = Boolean(urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
  }, []);

  // get default facets for types
  React.useEffect(() => {
    let algoliaIndexes = '';

    // China part ---start---
    if (!isChina) {
      const search = location.search;
      let urlParameter = new URLSearchParams(search).get('deal');
      if (urlParameter) {
        urlParameter = urlParameter.replaceAll('-', ' ');
        let itemFilter = {
          hitsPerPage: 1,
          facetFilters: [['type:Listing deal', 'type:Listing trade event', 'type:Listing vendor']],
          query: urlParameter
        };
        getListing(algoliaIndexes, itemFilter, algoliaSettings, undefined, isSumOrFiltersScores).then(response => {
          if (response && response.hits.length !== 0) {
            response.hits.forEach(hit => {
              if (urlParameter && hit.urlParameter.toLowerCase() === urlParameter.toLowerCase()) {
                setIdDealModalItem(hit);
              }
            });
            toggle();
          }
        });
      }
    }
    // China part ---end---
  }, []);
  const href = typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.href : null;
  let prevFacetFilters = usePrevious(facetFilters);
  const prevPage = usePrevious(page);
  React.useEffect(() => {
    const queryIndexes = Object.keys(queryParams).filter(k => k.indexOf(`${searchIndexParams}_asc_`) > -1)[0];
    let algoliaIndexes = '';
    if (queryIndexes) {
      algoliaIndexes = queryIndexes;
    } else {
      algoliaIndexes = get(params, 'SearchIndex');
    }
    let tag = 'tags:';
    if (canUseDOM) {
      const hash = window.location.hash;
      const hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      return `type:${value}`;
    });
    applycurrentTypes(types);
    const facetNames = getFacetNamesValue(filterData);
    let filters;
    const currentTagTypeArray = facetFilters.filter(subArray => subArray.some(item => item.startsWith('type:')));
    const currentTagType = currentTagTypeArray[0] && currentTagTypeArray[0][0] ? currentTagTypeArray[0][0].split(':')[1] : null;
    if (currentTagType === 'Event' || currentTagType === 'Offer And Deal') {
      if (queryParams.datesRange) {
        filters = queryParams.datesRange.split('+').join(' ');
      } else {
        let filterValues = getAlgoliaTagsList(filterData);
        if (filterValues.indexOf(eventDatesRange) > -1) {
          filters = `datesRange.to > ${Date.parse(new Date()) / 1000}`;
        }
      }
    }
    if (queryParams.valid) {
      filters = queryParams.valid.split('+').join(' ');
    }
    const isLoadedFeatureItem = firstRendering && types.length == 1 && types[0] == 'type:Event';
    const isContainsType = facetFilters.some(subArray => subArray.some(item => item.startsWith('type:')));
    const itemFilters = {
      filters,
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFilters, [tag]],
      hitsPerPage: isLoadedFeatureItem ? pagesize + 1 : pagesize,
      page: page
    };
    const removeTypeFromArray = arr => arr.filter(subArray => !subArray.some(item => item.startsWith('type:')));
    const facetFiltersWithoutType = removeTypeFromArray(facetFilters);
    const switchItemFilters = {
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFiltersWithoutType]
    };
    const listingRequest = () => {
      setLoading(true);
      if (isContainsType) {
        getListing(algoliaIndexes, itemFilters, algoliaSettings, undefined, isSumOrFiltersScores).then(response => {
          setCountAlgoliaCalls(prev => prev + 1);
          setResult(response);
          applySetFilters(false);
          setNbHits(response.nbHits);
          if (response.hits.length) {
            if (buttonPressed) {
              setButtonPressed(false);
              const resultsBlocks = document.querySelectorAll('.results');
              if (resultsBlocks.length) {
                const lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
                const focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
                if (focusableList.length) {
                  const lastFocusable = focusableList[focusableList.length - 1];
                  lastFocusable.focus();
                }
              }
            }
            setHits(hits.concat(response.hits[0].featured && isLoadedFeatureItem && response.nbPages > 1 ? response.hits.splice(0, response.hits.length - 1) : response.hits));
          }
          setTimeout(function () {
            if (canUseDOM) {
              window.onscroll = () => {};
            }
          }, 100);
          setLoading(false);
          setFirstRendering(false);
          setResetAllFilters(false);
        });
      }
      getListing(algoliaIndexes, switchItemFilters, algoliaSettings, undefined, isSumOrFiltersScores).then(response => {
        if (countAlgoliaCalls === 0) {
          setdefaultFacets(response.facets);
        }
        setFacets(response.facets);
        setLoading(false);
      });
    };
    if (resetAllFilters) {
      listingRequest();
    } else if (setFilters) {
      listingRequest();
    } else if (isTypeSetToUrl && countAlgoliaCalls <= 1) {
      setIsTypeSetToUrl(false);
      listingRequest();
    } else {
      if (!isFirstLoadWithoutFacets.current) {
        // compare previous facet filters value to escape extra request

        if (prevFacetFilters && prevFacetFilters.length === 0) {
          prevFacetFilters = undefined;
        }
        if (JSON.stringify(facetFilters) !== JSON.stringify(prevFacetFilters) || page !== prevPage) {
          listingRequest();
        }
      } else {
        isFirstLoadWithoutFacets.current = false;
      }
    }
  }, [resetFilter, setFilters, page, buttonPressed, resetAllFilters, isTypeSetToUrl]);
  const resetFilterCallback = () => {
    setFacets(undefined);
    setResult(undefined);
    // setNbHits(0);
    // setNbHits2(0);
    setHits([]);
    setpage(0);
    setResetFilter(true);
  };
  const resetAllFiltersCallback = () => {
    setResetAllFilters(true);
  };
  const {
    bannerClickAnalytics,
    listingItemAnalytics,
    titleClickAnalytics,
    visitWebsite: visitWebsiteAnalytics,
    navBubblesAnalytics,
    prevNextNavAnalytics,
    addToFavAnalytics,
    exploreMoreAnalytics,
    mobileSlidesAnalytics,
    videoAnalytics,
    socialAnalytics,
    discoverMoreClickAnalytics,
    seeMoreAnalytics,
    readMoreAnalytics,
    filterShowResultsAnalytics,
    filterClearAllDateAnalytics,
    filterClickAnalytics,
    expandCollapseAnalytics,
    buttonClickAnalytics
  } = fields.data;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const analytics = get(fields, 'data.analytics.parameters');
  const loadMore = () => {
    if (canUseDOM) {
      window.onscroll = () => {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    setpage(prevState => prevState + 1);
    if (eventsAnalytics['loadMoreAnalytics']) {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loadMoreAnalytics'], params));
    }
  };
  const setListingFilter = filtersRecived => {
    setpage(0);
    setHits([]);
    applySetFilters(true);
    // setdefaultFacets(result && result.facets);
    setFacetsStats(result && result.facets_stats);
    isFirstLoadWithoutFacets.current = firstRendering && facetFilters.length === 0;
  };
  React.useEffect(() => {
    if (modalVideoState.type === 'media') {
      let timer;
      if (modalVideoState.visiblePlayButton) {
        timer = setTimeout(() => {
          setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
            visiblePlayButton: false
          }));
        }, 2000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
  }, [modalVideoState]);
  React.useEffect(() => {
    if (isShown) {
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        visiblePlayButton: true
      }));
    }
  }, [isShown]);
  if (!fields || !fields.data || !fields.data.listingConfiguration || !fields.data.overwiewPages || !fields.data.overwiewPages.pages) {
    console.warn('RecommendationListing component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[RecommendationListing component is empty: please provide datasource]");
    }
    return null;
  }
  const getHostLink = () => {
    if (canUseDOM) {
      const urlParams = new URLSearchParams(window.location.search);
      const type = urlParams.get('type');
      const slug = type ? tagsSlugMap[type] : '';
      return `${window.location.origin}${slug}`;
    }
    return window.location.origin;
  };
  const modalPlayButtonHandler = () => {
    if (modalVideo.current) {
      if (modalVideoState.playing) {
        modalVideo.current.pause();
      } else {
        modalVideo.current.play();
      }
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        playing: !modalVideoState.playing
      }));
    }
  };
  let checkMouseMoved;
  if (canUseDOM) {
    checkMouseMoved = throttle(() => {
      if (!modalVideoState.visiblePlayButton) {
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          visiblePlayButton: true
        }));
      }
    }, 300);
  }
  const renderVideo = styles => {
    if (!modalVideoState.src || !modalVideoState.type) {
      return null;
    }
    if (modalVideoState.type === 'external') {
      return /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          toggle();
          setModalVideoState(emptyModalVideo);
        },
        className: clsx(styles, 'modal-yt-iframe-container')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-yt-iframe-ar-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        width: "560",
        height: "315",
        src: modalVideoState.src,
        title: modalVideoState.title,
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerPolicy: "strict-origin-when-cross-origin",
        allowFullScreen: true,
        className: "modal-yt-iframe"
      })));
    }
    if (modalVideoState.type === 'media') {
      return /*#__PURE__*/React.createElement("div", {
        onMouseMove: checkMouseMoved,
        className: clsx(styles, {
          'hidden-play-button': !modalVideoState.visiblePlayButton
        })
      }, /*#__PURE__*/React.createElement("video", {
        ref: modalVideo,
        className: clsx('modal-video', {
          'modal-video--load-over': !modalVideoState.loading
        }),
        playsInline: true,
        loop: true,
        onProgress: () => {
          if (modalVideoState.loading) {
            setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
              loading: false
            }));
          }
        },
        muted: false,
        preload: "auto",
        autoPlay: false
      }, /*#__PURE__*/React.createElement("source", {
        src: modalVideoState.src,
        type: "video/mp4"
      }), /*#__PURE__*/React.createElement("track", {
        kind: "captions"
      })), modalVideoState.loading ? /*#__PURE__*/React.createElement(Loader, {
        color: "#000000"
      }) : /*#__PURE__*/React.createElement("button", {
        className: clsx('btn--reset modal-play-button', {
          'modal-play-button--playing': modalVideoState.playing
        }),
        onClick: modalPlayButtonHandler
      }, modalVideoState.playing ? /*#__PURE__*/React.createElement(IconPauseItem, null) : /*#__PURE__*/React.createElement(IconPlay, null)));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    componentTabIndex: "disabled"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "Listing"
  }, Object.keys(dealModalItem).length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: toggle
  }, /*#__PURE__*/React.createElement(DealModalBlock, {
    event: dealModalItem,
    lang: currentLang,
    hostLink: getHostLink(),
    analytics: socialAnalytics,
    params: params,
    fields: fields,
    pageTitle: pageTitle,
    rtl: rtl
  }))), filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    pinned: pinned,
    fields: filterData,
    currentTypes: currentTypes,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    FiltersCopy: FiltersCopy,
    isTagPage: isTagPage,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    buttonsDictionary: buttonsDictionary,
    imageDictionary: imageDictionary,
    firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
    eventsAnalytics: eventsAnalytics,
    analytics: {
      filterShowResultsAnalytics,
      filterClearAllDateAnalytics,
      filterClickAnalytics,
      params
    },
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndexParams,
    setIsTypeSetToUrl: setIsTypeSetToUrl
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), /*#__PURE__*/React.createElement(React.Fragment, null, currentTypes.map((type, index) => {
    if (type === 'type:Article' && typeFromUrl === 'Article' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Article')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Article') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(ArticleBlock, {
            item: hit,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              eventsAnalytics,
              params
            },
            removeDate: true
          }));
        }
      }))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:PressRelease' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:PressRelease')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        key: `results-row-${index}`
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), hits && hits.map((hit, index) => {
        return /*#__PURE__*/React.createElement(ResultItem, {
          key: index,
          item: hit,
          language: currentLang,
          params: params,
          analitycs: {
            bannerClickAnalytics: bannerClickAnalytics,
            listingItemAnalytics: listingItemAnalytics
          }
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-2"
      }), "s", ' ');
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Article Insights' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Article Insights')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Article Insights') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
            key: index
          }, /*#__PURE__*/React.createElement(ArticleBlock, {
            item: hit,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              eventsAnalytics,
              params
            },
            removeDate: true
          }));
        }
      }))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Long Report Overview' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Long Report Overview')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Long Report Overview') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
            key: index
          }, /*#__PURE__*/React.createElement(ArticleBlock, {
            item: hit,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              eventsAnalytics,
              params
            },
            removeDate: true
          }));
        }
      }))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Venue' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Venue')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Venue') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(VenueBlock, {
            item: hit,
            dictionary: dictionary,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              titleClickAnalytics,
              bannerClickAnalytics,
              addToFavAnalytics,
              seeMoreAnalytics,
              readMoreAnalytics,
              addToFavoriteAnalytics: get(getAnaliticsParamFromArray(analytics, 'Add Venue To Shortlist Param'), '0'),
              removeFromFavoriteAnalytics: get(getAnaliticsParamFromArray(analytics, 'Remove Venue From Shortlist Param'), '0'),
              params
            }
          }));
        }
      }), !loading && hits && !hits.length ? /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, getDictionaryItem(dictionary, 'venues not found')) : null)))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Curator' && typeFromUrl === 'Curator' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Curator')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Curator') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 curator-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(CuratorBlock, {
            key: index,
            item: hit,
            seeMore: seeMore,
            analytics: {
              eventsAnalytics,
              params
            },
            modalVideoState: modalVideoState,
            isMultipleSocialMedia: true,
            setModalVideoState: setModalVideoState,
            toggle: toggle,
            hostLink: location.pathname,
            selectedPrimaryColor: 'var(--main-color)',
            parentParams: params
          }));
        }
      }))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:POI' && typeFromUrl === 'POI' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:POI')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('POI') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 poi-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(POIBlock, {
            item: hit,
            curatorsCopy: curatorPick,
            hostLink: getHostLink(),
            dictionary: getDictionaryItem(dictionary, 'reviews') || '',
            analytics: {
              eventsAnalytics,
              bannerClickAnalytics: eventsAnalytics['bannerClickAnalytics'],
              titleClickAnalytics: eventsAnalytics['titleClickAnalytics'],
              navBubblesAnalytics,
              prevNextNavAnalytics,
              addToFavAnalytics,
              exploreMoreAnalytics,
              mobileSlidesAnalytics,
              params
            }
          }));
        }
      }))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Event' && typeFromUrl === 'Event' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Event')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, hit && hit.featured && index === 0 && !isShowRuleIsHide(hit) ? /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-xl-9 offset-xl-1 common-listing-styles",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "events__featured-block"
        }, /*#__PURE__*/React.createElement(FeaturedEventBlock, {
          userProfile: userProfile,
          event: hit,
          curatorsCopy: curatorPick,
          lang: currentLang,
          hostLink: getHostLink(),
          multipleDates: multipleDates,
          analytics: {
            eventsAnalytics,
            params
          },
          countryItems: countryItems,
          themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)]
        }))) : null);
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-xl-9 offset-xl-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', hits.map((hit, index) => {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, hit && hit.featured && index === 0 && !isShowRuleIsHide(hit) ? null : /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-sm-6 col-md-4 events-item-col-outer d-flex"
        }, /*#__PURE__*/React.createElement(EventBlock, {
          userProfile: userProfile,
          event: hit,
          curatorsCopy: curatorPick,
          lang: currentLang,
          hostLink: getHostLink(),
          multipleDates: multipleDates,
          analytics: {
            eventsAnalytics,
            params
          },
          countryItems: countryItems,
          themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)]
        })));
      })))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Itineraries' && typeFromUrl === 'Itineraries' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Itineraries')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-xl-9 offset-xl-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-sm-6 col-md-4 events-item-col-outer"
        }, /*#__PURE__*/React.createElement(RecommendationItenaryBlock, {
          item: hit,
          day: day,
          curatorsCopy: curatorPick,
          days: days,
          hostLink: getHostLink(),
          analytics: {
            eventsAnalytics,
            params
          }
        })));
      }))))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Offer And Deal' && typeFromUrl === 'Offer And Deal' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Offer And Deal')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          rowGap: '20px'
        }
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Offer And Deal') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: `col-12 col-sm-6 col-md-4 ${isShowRuleIsHide(hit) ? 'd-flex' : ''}`,
            key: index
          }, /*#__PURE__*/React.createElement(OfferAndDeal, {
            userProfile: userProfile,
            fromText: fromText,
            offText: offText,
            expiresSoonText: expiresSoonText,
            moreInfoText: moreInfoText,
            bookNowText: bookNowText,
            readMoreText: readMoreText,
            readLessText: readLessText,
            termsAndConditionsText: termsAndConditionsText,
            deal: hit,
            rtl: rtl,
            currency: 'AED',
            currencyIndex: 1,
            socialSharing: socialSharing,
            eventsAnalytics: eventsAnalytics,
            params: params,
            ratingTextStars: ratingTextStars,
            ratingTextStar: ratingTextStar,
            countryItems: countryItems,
            gridMode: false,
            useTruncate: false
          }));
        }
      })));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:University') {
      const anualFee = getDictionaryItem(dictionary, 'Annual Fee Range') || 'Anual Fee Range';
      const fieldOfStudy = getDictionaryItem(dictionary, 'Field Of Study') || 'Field of study';
      const visitWebsite = getDictionaryItem(dictionary, 'Visit website') || 'Visit website';
      const AED = getDictionaryItem(dictionary, 'AED') || 'AED';
      const universityDescription = getDictionaryItem(dictionary, 'university description');
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row itinerary-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "universities-container"
      }, hits && hits.map((hit, index) => {
        return /*#__PURE__*/React.createElement("div", {
          className: "university-container",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "university-container__row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "university-main-container"
        }, /*#__PURE__*/React.createElement(UniversityBlock, {
          hit: hit,
          rtl: rtl,
          lang: {
            anualFee,
            visitWebsite,
            universityDescription,
            fieldOfStudy,
            AED
          },
          analytics: {
            bannerClickAnalytics,
            titleClickAnalytics,
            visitWebsiteAnalytics,
            prevNextNavAnalytics,
            addToFavAnalytics,
            exploreMoreAnalytics,
            mobileSlidesAnalytics,
            params
          }
        }))));
      })))));
    }
  }), currentTypes.map((type, index) => {
    if (type === 'type:Services Page') {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map((hit, index) => {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "col-sm-4 col-12"
        }, /*#__PURE__*/React.createElement(ServicesBlock, {
          service: hit,
          hostLink: "",
          rtl: rtl
        }));
      })))));
    }
  }), currentTypes.some(type => type === 'type:Listing deal' || type === 'type:Listing trade event' || type === 'type:Listing vendor') && /*#__PURE__*/React.createElement("div", {
    className: "results DEALS-M44"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row itinerary-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-1 col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator-featured"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals-container",
    style: {
      '--backgroundPrimaryColor': backgroundPrimaryColor
    }
  }, hits && hits.map((hit, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "deal-container",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "deal-container__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "deal-main-container"
    }, /*#__PURE__*/React.createElement(DealBlock, {
      event: hit,
      lang: currentLang,
      hostLink: getHostLink(),
      analytics: {
        expandCollapseAnalytics,
        buttonClickAnalytics
      },
      params: params,
      route: route,
      fields: fields,
      socialSharing: socialSharing,
      socialAnalytics: socialAnalytics
    }))));
  })))))), currentTypes.some(type => facetFilters.length && facetFilters[0].length && facetFilters[0][0].includes('type') ? type === 'type:Video Details Page' && facetFilters[0][0] === 'type:Video Details Page' : type === 'type:Video Details Page') && /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row itinerary-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-1 col-xl-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits && hits.map((hit, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: `videoHolder ${videoMedia}`
    }, /*#__PURE__*/React.createElement(VideoBlock, {
      item: hit,
      index: index,
      hostLink: '',
      key: index,
      analytics: analytics,
      params: params,
      discoverMoreLink: getHostLink()
    }));
  }))))), currentTypes.map((type, index) => {
    if (type === 'type:Restaurant' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Restaurant')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results poi-styles",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row restaurantsListingRowGap"
      }, hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Restaurant') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4",
            style: {
              display: 'flex'
            },
            key: index
          }, /*#__PURE__*/React.createElement(RestaurantsCard, {
            analyticsCallback: eventsAnalytics,
            item: hit,
            params: params,
            reviews: getDictionaryItem(dictionary, 'reviews') || '',
            rtl: rtl,
            textToHighlight: ''
          }));
        }
      }))))));
    }
  }), currentTypes.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-1 col-xl-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits && hits.map((hit, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
      key: index
    }, /*#__PURE__*/React.createElement(ArticleBlock, {
      item: hit,
      copyBy: byCopy,
      copyMinread: MinRead,
      lang: currentLang,
      hostLink: getHostLink(),
      analytics: {
        eventsAnalytics,
        params
      },
      removeDate: true
    }));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, !loading && !hits.length && /*#__PURE__*/React.createElement("h4", {
    className: "  message-search-result-empty",
    dangerouslySetInnerHTML: {
      __html: messageSearchResultEmpty
    }
  }))), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: LoadMoreCopy,
    onClick: loadMore,
    nbHits: result.nbHits,
    loadedHits: (page + 1) * pagesize,
    viewedNofMLabel: viewedNofMLabel
  })), /*#__PURE__*/React.createElement(Modal, {
    showMobileClose: true,
    fullPageCover: true,
    fullPageVideo: true,
    isShown: isShown,
    hide: () => {
      toggle();
    }
  }, actualSSR ? null : renderVideo(videplayerStyles)))));
};
const RecommendationListing = props => checkJssError(props, RecommendationListingComponent, props.fields.data.listingConfiguration);
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `  ${eventStyle} ${poiStyle} ${articleStyle} ${itemStyles} ${loadMoreButtonStylesLtr} ${curatorltrStyles} ${curatorStyle} ${commonStyles} ${rtl ? curatorRtlStyles : curatorltrStyles} ${rtl ? stylesRTL : stylesLTR} ${commonListingStyles}
    ${rtl ? commonListingRtlStyles : commonListingLtrStyles}`
  }, children);
};
export const commonStyles = "c5is86k";
export const eventStyle = "etdpu34";
export const articleStyle = "atwzv95";
export const poiStyle = "p1hmzzl7";
export const curatorStyle = "c11ljqv4";
export const stylesLTR = "s9dmp0i";
export const stylesRTL = "su0y5dr";
export default RecommendationListing;